import { EventEmitter, OnInit } from '@angular/core';
import { ThemeConfig } from '../../../core/helpers/theme-config';
var showFacets = ThemeConfig.get('catalog', 'show-more') || 10;
var FacetListComponent = /** @class */ (function () {
    function FacetListComponent() {
        this.open = false;
        this.facetToggled = new EventEmitter();
        this.showMoreToggled = new EventEmitter();
    }
    FacetListComponent.prototype.isApplied = function (facet) {
        return this.appliedFacets.indexOf(facet.code) !== -1;
    };
    FacetListComponent.prototype.ngOnInit = function () {
        this.facets = this.facets.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLocaleLowerCase())
                return -1;
            if (a.name.toLowerCase() > b.name.toLocaleLowerCase())
                return 1;
            return 0;
        });
    };
    Object.defineProperty(FacetListComponent.prototype, "showFacets", {
        get: function () {
            return showFacets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetListComponent.prototype, "hasMoreFacets", {
        get: function () {
            return this.facets.length > this.showFacets;
        },
        enumerable: true,
        configurable: true
    });
    FacetListComponent.prototype.toggled = function (code) {
        this.facetToggled.emit(code);
    };
    FacetListComponent.prototype.showMore = function () {
        this.showMoreToggled.emit();
    };
    return FacetListComponent;
}());
export { FacetListComponent };
